import React, { ReactElement, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import styles from "../../styles/layouts/ModalLayout.module.scss";
interface IProps {
  children: React.ReactNode;
  handleToggle: () => void;
  title?: string | ReactElement;
  show: boolean;
  size?: number;
  dropDowns?: boolean;
  isTippingPreview?: boolean;
}
const ModalLayout = ({
  children,
  handleToggle,
  title,
  dropDowns,
  show,
  size = 340,
  isTippingPreview = false

}: IProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  // Close when clicking outside the modal content (for tipping preview)
  useEffect(() => {
    if (!isTippingPreview || !show) return;
    const handleOutsideClick = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        handleToggle();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isTippingPreview, show, handleToggle]);

  return (
    <Modal
      show={show}
      onHide={handleToggle}
      backdrop="static"
      keyboard={false}
      // centered
      className={styles.modal_wrapper}
    >
      <div
        ref={containerRef}
        className={
          dropDowns
            ? `${styles.addStepTwo} ${styles.modalLayout}`
            : styles.modalLayout
        }
        // className={styles.modalLayout}
        style={{ width: `${size}px` }}
      >
        <Modal.Header closeButton closeVariant="black" style={{ borderBottom: !isTippingPreview ? '' : 'none' }} >
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className={`${dropDowns && styles.addDropOrgnaization}`}>
          {children}
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default ModalLayout;
